<template>
  <div class="form-group">
    <label v-if="label">{{ label }}</label>
    <input
      v-model="iValue"
      type="number"
      class="form-control"
      :placeholder="placeholder"
    />
    <span class="unit">{{ unit }}</span>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Number, String],
      default: '',
    },
    label: {
      type: [String],
      default: '',
    },
    placeholder: {
      type: [String],
      default: '',
    },
    unit: {
      type: [String],
      default: 'px',
    },
  },

  computed: {
    iValue: {
      get() {
        return this.value
      },

      set(newVal) {
        this.$emit('input', newVal)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.form-group {
  position: relative;
  .unit {
    position: absolute;
    right: 8px;
    top: 36px;
  }
  input[type='number'] {
    padding-right: 25px;
  }
}
</style>
